module.exports = {
    useEmulator: false
};